<template>
    <div class="body">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
        </div>
        <div v-if="!pageloader">
            <div class="card ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                    <div class="pl-1 mb-2">
                        <span class="fontsize14 black stylebold proximanova">More Details</span>
                    </div>
                    <div class="form">
                        <div class="row no-gutters mb-3">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col mt-3 pl-0">
                                    <div class="input-group">
                                        <select
                                            type="text"
                                            v-validate=" 'required' "
                                            name="Receive applications by"
                                            data-vv-as="Receive applications by"
                                            data-vv-scope="moredetails"
                                            class="input-create proximanova"
                                            onclick="this.setAttribute('value', this.value);"
                                            v-model="JobObject.communicationType"
                                            required
                                        >
                                            <option
                                                v-for="(type,index) in receivedTypes"
                                                :value="type.indexDetailName"
                                                :key="index"
                                            >{{type.indexDetailName}}</option>
                                        </select>
                                        <span class="bar"></span>
                                        <label class="label-create required proximanova">Receive applications by</label>
                                    </div>
                                </div>
                                <div v-if="errors.has('moredetails.Receive applications by')" class="alert-danger ml-2">{{ errors.first('moredetails.Receive applications by') }}</div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="col mt-2 pl-lg-2 pl-sm-0">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        name="Email"
                                        data-vv-as="Email"
                                        class="input-create proximanova"
                                        v-model="JobObject.emailId"
                                        autocomplete="off"
                                        v-validate=" 'required' "
                                        data-vv-scope="moredetails"
                                        required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required proximanova" >Email Id</label>
                                </div>
                                <div class="col d-flex ml-2">
                                    <div v-if="errors.has('moredetails.Email')" class="alert-danger">{{ errors.first('moredetails.Email') }}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <label class="small-label required mb-2 mt-4">Add Screening Questions</label>
                        <div class="row no-gutters">
                            <!-- <div class="col-12 col-md-6 col-lg-6">
                                <div class="d-flex input-group pl-0 col-12 mt-2 mb-2"  >
                                  <div class="input-group-prepend">
                                      <span class="input-group-append img-input-group" id="basic-text1">
                                        <img src="../../assets/Search.svg" width="20px" alt="search" class="imgborder1 " />
                                      </span>
                                  </div>
                                  <input class="form-control searchtext font14-opacity60 bigger-font "  type="text" placeholder="Search Questions" id="searchquestions" autocomplete="off" aria-label="Search"/>     
                                </div>
                            </div> -->
                            <div class="col-12 col-md-6 col-lg-6">
                              <div class="d-flex input-group col-12 pl-sm-0 mt-2 mb-2"  >
                                <input class="form-control searchtext font14-opacity60 bigger-font" v-model="customQuestion"  type="text" placeholder="Add Custom Questions" id="customquestions" autocomplete="off" aria-label="Search"/>
                                <div class="input-group-prepend">
                                      <span class="input-group-append1 img-input-group" id="basic-text1" @click="addCustomScreeningQuestion">
                                        <span class="ml-4 pointer  backgroundcolor5 prependadd borderradiushalf stylebold" title="add">+</span>
                                      </span>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div class="row no-gutters mt-3">
                          <div v-if="existingScreeningQuestions.length > 0" class="d-flex flex-wrap mb-3 col" >
                              <div v-for="(screenqsn, index) in existingScreeningQuestions" :key="index" >
                                <div class="p-1 pl-2 pr-2 mr-3 mt-2 border-0 black60 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                    {{screenqsn.question}}
                                    <span class="ml-4 pointer backgroundcolor5 borderradiushalf stylebold" title="add" @click="addExistingScreeningQuestion(index)">+</span>
                                </div>
                              </div>
                          </div>
                        </div>
                        <div class="col pl-0 mb-3">
                          <span class="fontsize12 black proximanova stylebold ml-1">Questions Added</span>
                          <div class="row no-gutters mt-3">
                            <div v-if="JobObject.screeningQuestionsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(screenqsn, index) in JobObject.screeningQuestionsList" :key="index" >
                                  <div class="pl-2 pr-2 p-1 mr-3 mt-2 black60 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{screenqsn.question}}
                                      <span class="ml-4 pointer backgroundcolorwhite borderradiushalf stylebold" title="close" @click="removeSelectedScreeningQuestion(index)">x</span>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card ml-3 mr-3 mb-4 p-4 mt-5">
                <div class="d-lg-flex d-md-flex justify-content-between">
                    <div class="d-flex flex-column">
                        <span class="fontsize12 black60 proximanova">By continuing, you agree with</span>
                        <span class="fontsize12 stylebold black60 proximanova">Worknotion <a :href="wndata.termsandConditions" target="_blank" rel="noopener noreferrer" class="proximanova blue pointer">Terms & Conditions</a></span>
                    </div>
                    <div class="d-flex justify-content-end btnsection">
                        <button class="btn fontsizemd navtoPage borderradius20 proximanova" :disabled="saveasDraftBtnClicked || saveasPostBtnClicked" @click="openCancelModal">Cancel</button>
                        <img src="../../assets/uploadvideo.svg" width="32px" alt="uploading" class="img-fluid ml-2 mr-2" v-if="saveasDraftBtnClicked">
                        <button class="btn button-cancel11 ml-2 borderradius20 mr-2 navtoPage proximanova" :disabled="saveasDraftBtnClicked || saveasPostBtnClicked" v-if="!saveasDraftBtnClicked" @click="saveJobasDraft">Draft</button>
                        <button class="btn button-cancel11 mr-2 borderradius20 navtoPage proximanova" @click="openPreviewModal">Preview</button>
                        <img src="../../assets/uploadvideo.svg" width="32px" alt="uploading" class="img-fluid ml-2 mr-2" v-if="saveasPostBtnClicked">
                        <button class="btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd proximanova" id="moredtnbtn" :disabled="saveasDraftBtnClicked || saveasPostBtnClicked" v-if="!saveasPostBtnClicked && JobObject.screeningQuestionsList.length < 1" data-toggle="modal" data-target="#deleteBenefitpModal">Post job</button>
                        <button class="btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd proximanova" id="moredtnbtn" :disabled="saveasDraftBtnClicked || saveasPostBtnClicked" v-if="!saveasPostBtnClicked && JobObject.screeningQuestionsList.length > 0" @click="postaJob">Post Job</button>
                    </div>
                </div>
            </div>
            <!-- confirm modal view to delete benefits -->
            <div class="modal fade" id="deleteBenefitpModal" tabindex="-1" role="dialog" aria-labelledby="deleteExpModalLabel" aria-hidden="true">
                <div class="modal-dialog " role="document">
                    <div class="modal-content">
                        <div class="modal-header delete-modal">
                            <h5 class="modal-title fontsize20 black80 proximanova" id="deleteExpModalLabel">Are you sure you want to post this job without screening questions ?</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body modal-delete text-center">
                            <span class="btn button-cancel11 borderradius20 mr-2 pr-4 pl-4 navtoPage proximanova" data-dismiss="modal" aria-label="Close" >No</span>
                            <span class="btn sign-up-button borderradius20 blackbackhroundsignin fontsizemd pr-4 pl-4 pointer proximanova" @click="postaJob">Yes</span>
                        </div>
                    </div>
                </div>
            </div>
            <cancel-modal v-if="showcancelModal" :JobObject="JobObject" @closeCancelModal="closeCancelModal"></cancel-modal>
            <preview-job-post-modal v-if="showPreviewJobModal" :JobObject="JobObject" @closePreviewModal="closePreviewModal"></preview-job-post-modal>
            <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
        </div>
    </div>
</template>
<script>
import { bus } from "@/main.js";
import cancelModal from './cancelModal.vue'
import httpbusiness from "@/js/http-business.js"
import httpjob from "@/js/http-postjob.js"
import previewJobPostModal from './PreviewJobModal.vue'
import APIErrorModal from '../../components/APIerrorpopup.vue'
import router from '../../router.js'
import wndata from '@/js/wn_data.json'
import $ from 'jquery'
export default {
    data() {
        return{
            pageloader: false,
            receivedTypes : [{indexDetailName : 'email'},{indexDetailName : 'phoneNumber'}],
            existingScreeningQuestions : [
                {question : 'Explain a time when you took the initiative on a project.'}, 
                {question : 'Tell me about a time when you used creativity to overcome a dilemma.'},
                {question : 'What’s the best idea you’ve come up with on a team-based project?'}, 
                {question :'How do you approach problems? What’s your process?'}],
            //job details section
            customQuestion : '',
            receivedApplicationType : '',
            emailId : '',
            // selectedScreeningQuestions : [],
            //cancel modal
            showcancelModal : false,
            showPreviewJobModal : false,
            saveasDraftBtnClicked : false,
            saveasPostBtnClicked : false,
            moreDetailsDisable : true,
            displayAPIerrorModal : false,
            //json
            wndata : {},
        }
    },
    props : [
        'JobObject'
    ],
    components : {
        cancelModal,
        previewJobPostModal,
        APIErrorModal
    },
    mounted() {
        console.log("job object : ", this.JobObject)
        this.wndata = wndata;
        // this.selectedScreeningQuestions = this.JobObject.screeningQuestionsList;
        window.scrollTo(0, 0)
    },
    methods : {
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      openCancelModal() {
        this.$validator.validateAll("moredetails").then((isValid) => {
          if(isValid){
        this.showcancelModal = true;
          }
        })
      },
      closeCancelModal(statusObj) {
        console.log(statusObj)
        this.showcancelModal = false;
      },
      openPreviewModal() {
        // this.JobObject.screeningQuestionsList = this.selectedScreeningQuestions;
        this.$validator.validateAll("moredetails").then((isValid) => {
          if(isValid){
        console.log("cliked on preview")
        this.showPreviewJobModal = true;
        this.JobObject.selectedCity = this.JobObject.selectedMultiselectLocCity;
        this.JobObject.selectedCountry = this.JobObject.selectedMultiselectLocCountry;
        this.JobObject.isMoreDetailsCompleted = true;
          }
        })
      },
      closePreviewModal(statusObj) {
        this.showPreviewJobModal = false;
      },
      saveJobasDraft(){
        this.$validator.validateAll("moredetails").then((isValid) => {
          if(isValid){
        this.saveasDraftBtnClicked = true;
        this.JobObject.jobStatus = 'DRAFT'
        // this.JobObject.screeningQuestionsList = this.selectedScreeningQuestions;
        this.JobObject.isMoreDetailsCompleted = true;
        this.saveJobDetails()
          }
        })
      },
      validateMoreDetails(){
        this.$validator.validateAll("moredetails").then((isValid) => {
          if(isValid){
            this.moreDetailsDisable = false;
            console.log("valid")
            document.getElementById("moredtnbtn").classList.add("blackbackhroundsignin");
          } else{
            this.moreDetailsDisable = true;
            console.log("not valid")
            document.getElementById("moredtnbtn").classList.remove("blackbackhroundsignin");
          }
        })
      },
      postaJob() {
        this.$validator.validateAll("moredetails").then((isValid) => {
          if(isValid){
        $('#deleteBenefitpModal').modal('hide')
        this.saveasPostBtnClicked = true;
        this.JobObject.jobStatus = 'POST'
        // this.JobObject.screeningQuestionsList = this.selectedScreeningQuestions;
        this.JobObject.isMoreDetailsCompleted = true;
        this.saveJobDetails()
          }
        })
      },
      saveJobDetails(){
        var vm = this;
        let finalObj = {
          jobId : this.JobObject.jobId,
          companyProfileId : this.JobObject.companyProfileId,
          employeeId : this.JobObject.employeeId,
          employmentTypeId : this.JobObject.selectedEmploymentType,
          titleId : this.JobObject.titleId,
          jobTitle : this.JobObject.jobTitle,
          jobDesc : this.JobObject.jobDescription,
          seniorityId : this.JobObject.selecetdSeniority,
          jobStatus : this.JobObject.jobStatus,
          payScaleFrom : this.JobObject.selectedPayScaleFrom,
          payScaleTo : this.JobObject.selectedPayScaleTo,
          countryId : this.JobObject.country,
          stateId : this.JobObject.state,
          cityId : this.JobObject.city,
          zipcode : this.JobObject.pinCode,
          companyBenefitsList : this.JobObject.companyBenefitsList,
          addedSkillsList : this.JobObject.addedSkillsList,
          communicationType : this.JobObject.communicationType,
          emailId : this.JobObject.emailId,
          creationUserI : this.JobObject.creationUserI,
          updatedUserI : this.JobObject.updatedUserI,
          jobActive : 'ACTIVE',
          screeningQuestionsList : this.JobObject.screeningQuestionsList,
          jobPostedBy : this.JobObject.jobPostedBy
        }
        console.log("final job object : ", finalObj)
        httpjob.post('/postjob/PostingUserInfo', finalObj)
        .then((response) => {
          console.log(response)
          this.saveasDraftBtnClicked = false;
          this.saveasPostBtnClicked = false;
          if(response.data && response.data.errorCode=='1030'){
            vm.$toast.success(this.JobObject.jobStatus == 'POST' ? "Job Posted Successfully" : "Saved as a draft Successfully")
            this.navigateToJobsList(this.JobObject.jobStatus)
          }else if(response.data && response.data.errorCode=='1029'){
            vm.$toast.success("Job Updated Successfully")
            this.navigateToJobsList(this.JobObject.jobStatus)
          }else{
            vm.$toast.error(response.data.errorMessage)
          }
        }).catch((e) => {
          console.log(e.response)
          this.saveasDraftBtnClicked = false;
          this.saveasPostBtnClicked = false;
          this.displayAPIerrorModal = true;
        })
      },
      navigateToJobsList(jobStatus){
        if(jobStatus == 'POST'){
          router.push({
            name : 'postedJobs'
          })
        }else{
          router.push({
            name : 'draftJobs'
          })
        }
      },
      addExistingScreeningQuestion(ind) {
        let questionObj = {
          questionId : null,
          question : this.existingScreeningQuestions[ind].question,
          creationUserI : this.JobObject.emailId 
        }
        this.JobObject.screeningQuestionsList.push(questionObj)
        this.existingScreeningQuestions.splice(ind,1)
        console.log(this.JobObject)
        //this.validateMoreDetails()
      },
      addCustomScreeningQuestion() {
        let questionObj = {
          questionId : null,
          question : this.customQuestion,
          creationUserI : this.JobObject.emailId,
          updatedUserI: this.JobObject.emailId 
        }
        if(this.customQuestion.length > 0) {
          this.JobObject.screeningQuestionsList.push(questionObj);
          this.customQuestion = ''
          console.log(this.JobObject)
        }
        //this.validateMoreDetails()
      },
      removeSelectedScreeningQuestion(index){
        this.JobObject.screeningQuestionsList.splice(index, 1)
        console.log(this.JobObject)
        //this.validateMoreDetails()
      }
    }
}
</script>
<style scoped>
@import '../../css/vue-multiselect.min.css';
@import '../../css/vue2-datepicker.css';
.nav-link {
  padding: 0px 0px 0px 0px;
}
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 0px 0px 3px 0px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.edit {
  cursor: pointer;
  border: 1px solid rgba(31, 31, 31, .1);
  border-radius: 50%;
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 8px;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.list-text-color {
  color: #0078FF ;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
.nameblock {
  padding-left: 0 !important;
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  /* border-bottom: 1px solid #757575; */
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important; 
}
.input-group-append{
  background-color: rgba(161, 166, 179,0.1);
  padding: 2px 10px;
  border-radius: 10px 0 0 10px;
}
.input-group-append1{
  background-color: rgba(161, 166, 179,0.1);
  padding: 6px 10px;
  border-radius: 0 10px 10px 0;
}
.searchtext{
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.2);
    border: #DDDFE5;  
}
.searchtext:focus{
  background-color: rgba(161, 166, 179,0.2);
}
.backgroundcolor5{
  padding: 0 6px;
}
.backgroundcolor6{
  padding: 0 6px 3px 6px;
}
.backgroundcolorwhite{
  padding: 0 7px;
}
/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  font-size: 14px !important;
  transition : ease-out 0.3s;
	position: relative;
	z-index : 1;
}
/* modal styles */
.modal{
    margin-top: 15%;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
.delete-modal{
  border: none;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .btnsection{
      margin-top: 10px !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
